import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DialogModal } from './dialog';
const DialogServiceContext = React.createContext(() => {
    throw new Error('Please ensure you register the dialog provider!');
});
export const useDialog = () => React.useContext(DialogServiceContext);
export const DialogServiceProvider = ({ children }) => {
    const [dialogState, setDialogState] = React.useState(null);
    const isMounted = React.useRef(true);
    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
            setDialogState(null);
        };
    }, []);
    const openConfirmation = (options) => {
        if (isMounted.current) {
            setDialogState(options);
        }
    };
    const handleClose = () => {
        if (dialogState === null || dialogState === void 0 ? void 0 : dialogState.blocking) {
            return;
        }
        if (isMounted.current) {
            setDialogState(null);
        }
    };
    const handleSubmit = () => {
        if (isMounted.current) {
            setDialogState(null);
        }
    };
    const safeOnSubmit = () => {
        if (isMounted.current)
            handleSubmit();
    };
    const safeOnCancel = () => {
        if (isMounted.current)
            handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(DialogServiceContext.Provider, { value: openConfirmation, children: children }), dialogState && (_jsx(DialogModal, Object.assign({ open: Boolean(dialogState), onSubmit: safeOnSubmit, onClose: safeOnCancel }, dialogState)))] }));
};
//# sourceMappingURL=DialogService.js.map